import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  deSelectAllRoles,
  fetchClientRoles,
  setClientRolesLoading,
  updateFilters,
  updatePagination,
} from "@/reducers/client_user/roleAccess";

import TableSearch from "../../dataTables/TableSearch";

const SearchFilter = () => {
  const { filters, pagination } = useSelector((state) => state.clientRoles);

  const filterApplied = Object.values(filters).some(
    (item) =>
      item !== "" &&
      item !== null &&
      (Array.isArray(item) ? item.length > 0 : true),
  );

  const dispatch = useDispatch();
  /**
   * A function that handles the search event.
   *
   * @param {Event} e - the event object
   * @return {void}
   */
  const handleSearch = (e) => {
    dispatch(updateFilters({ search: e.target.value }));
  };
  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      dispatch(setClientRolesLoading(true));

      dispatch(
        updatePagination({
          ...pagination,
          currentPage: 1,
          isLastPage: false,
        }),
      );
      dispatch(deSelectAllRoles());
      dispatch(fetchClientRoles(filters));
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [filters.search]);

  return (
    <div className="SearchFilter_Wrapper">
      <div className="flex gap-[20px]">
        <TableSearch val={filters.search} handleChange={handleSearch} />
        {/* <FilterButton filterApplied={filterApplied} handleClick={() => { dispatch(showFilterModal(true)) }} /> */}
      </div>
    </div>
  );
};

export default SearchFilter;
